import { useState } from 'react';
import { Box, ToggleButtonGroup, ToggleButton, Tooltip } from '@mui/material';
import { LayoutGrid, List as ListIcon } from 'lucide-react';
import type { Fund } from '@diggens/types';
import { SpreadsheetSubmissionsTab } from './SpreadsheetSubmissionsTab';
import { CurrentPeriodTab } from './CurrentPeriodTab';
import { ICON_SIZES, ICON_STROKE } from '../../../constants/icons';

interface SubmissionsTabProps {
  fund: Fund;
}

type ViewMode = 'spreadsheet' | 'list';

export function SubmissionsTab({ fund }: SubmissionsTabProps) {
  const [viewMode, setViewMode] = useState<ViewMode>('spreadsheet');

  const handleViewChange = (_: React.MouseEvent<HTMLElement>, newView: ViewMode | null) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };

  const viewToggle = (
    <ToggleButtonGroup value={viewMode} exclusive onChange={handleViewChange} size="small" aria-label="view mode">
      <ToggleButton value="spreadsheet" aria-label="spreadsheet view">
        <Tooltip title="Spreadsheet View">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LayoutGrid size={ICON_SIZES.md} strokeWidth={ICON_STROKE} />
          </Box>
        </Tooltip>
      </ToggleButton>
      <ToggleButton value="list" aria-label="list view">
        <Tooltip title="List View">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <ListIcon size={ICON_SIZES.md} strokeWidth={ICON_STROKE} />
          </Box>
        </Tooltip>
      </ToggleButton>
    </ToggleButtonGroup>
  );

  return viewMode === 'spreadsheet' ? <SpreadsheetSubmissionsTab fund={fund} viewToggle={viewToggle} /> : <CurrentPeriodTab fund={fund} viewToggle={viewToggle} />;
}
